import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';

export const useItemPins = (item: useItemHandleFragment$data) =>
  Array.isArray(item.pins) ? item.pins : [];
